import React, { useState } from "react";
import RadioButton from "../../../UI/RadioButton";
import ProgressBar from "../../Layouts/Split_1/ProgressBar";
import {Lender} from "../../../../Constants/Lender";

const BasicQuestionnaireTwo = ({
  className,
  slideChange,
  textHeading,
  validation,
  backClick,
}) => {

  const [checkedQuestionOne, setCheckedQuestionOne] = useState("unchecked");
  const [checkedQuestionTwo, setCheckedQuestionTwo] = useState("unchecked");
  const [checkedQuestionThree, setCheckedQuestionThree] = useState("unchecked");
  const [checkedQuestionFour, setCheckedQuestionFour] = useState("unchecked");
  const [checkedQuestionFive, setCheckedQuestionFive] = useState("unchecked");
  const [checkedQuestionSix, setCheckedQuestionSix] = useState("unchecked");
  const [checkedQuestionSeven, setCheckedQuestionSeven] = useState("unchecked");

  const nextSlide = async (e) => {
    var bankLabel= document.querySelector("[for='" + e.target.id + "']").textContent;
    localStorage.setItem('bankName',bankLabel);
    slideChange(e);
  };

  const LenderList = Lender.map((value,index)=> {
    return (
      <RadioButton
        id={value.id}
        key={index}
        value={value.value}
        name="bank"
        className="banknames-radio bankks"
        labelName={value.label}
        labelClassName={`banknames-radio  checked ${checkedQuestionOne}`}
        onClick={nextSlide}
        validation={validation()}
      />
    )
  });


  return (
    <>

      <div id="slide-2" className={` slidetop_adjust ${className}`}>
      <ProgressBar value="15"/>
        <h4 className="text-center">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry.
        </h4>
        <div className="radio_buttons">
          {LenderList}
        </div>
        {/* <p className="text-center">
          <span className="back-btn" name="back01" id="back-1" onClick={previousSlide}>
            <u>{`<<`} Previous</u>
          </span>
        </p> */}
        <p className="text-center">
          <span
              className="back-btn"
              name="back01"
              children="<< Previous"
              onClick={backClick}
          ></span>
        </p>
      </div>
    </>
  );
};
export default BasicQuestionnaireTwo;
